import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("checking");
  useEffect(() => {
    const id = params.get("session_id");
    if (!id) return setStatus("error");
    let n = 0;
    let t;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${id}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          refreshUser();
          return;
        }
        if (data.status === "expired") return setStatus("error");
      } catch (e) {
        return setStatus("error");
      }
      if (++n < 15) t = setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
    return () => clearTimeout(t);
  }, [params, refreshUser]);
  return (
    <div className="container-bt flex min-h-[65vh] items-center justify-center py-16 text-center" data-testid="payment-success-page">
      <div className="max-w-md">
        {status === "checking" && <><Loader2 className="mx-auto mb-5 animate-spin text-bt-primary" size={40} /><h1 className="text-3xl">Confirming your membership...</h1></>}
        {status === "paid" && (
          <>
            <CheckCircle2 className="mx-auto mb-5 text-bt-primary" size={48} />
            <h1 className="text-4xl" data-testid="payment-success-title">Welcome to the membership.</h1>
            <p className="mt-3">Everything is unlocked. Your Growth Streak starts today.</p>
            <Link to="/account" className="btn-primary mt-8" data-testid="payment-go-dashboard">Go to my dashboard</Link>
          </>
        )}
        {status === "pending" && <><h1 className="text-3xl">Still processing</h1><p className="mt-3">This can take a minute. Refresh this page shortly.</p></>}
        {status === "error" && <><h1 className="text-3xl" data-testid="payment-error">We couldn't confirm that payment.</h1><Link to="/membership" className="btn-primary mt-8">Back to membership</Link></>}
      </div>
    </div>
  );
}

export const PaymentCancel = () => (
  <div className="container-bt flex min-h-[65vh] items-center justify-center py-16 text-center" data-testid="payment-cancel-page">
    <div className="max-w-md">
      <h1 className="text-4xl">No problem.</h1>
      <p className="mt-3">Nothing was charged. The free resources are still yours.</p>
      <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
        <Link to="/free" className="btn-primary">Free Growth Hub</Link>
        <Link to="/membership" className="btn-secondary">Back to membership</Link>
      </div>
    </div>
  </div>
);
